var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveModelOnMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 8.5V24C27.42 23.69 27.93 23.5 28.5 23.5C29.88 23.5 31 24.62 31 26C31 27.38 29.88 28.5 28.5 28.5H3.5C2.12 28.5 1 27.38 1 26C1 24.62 2.12 23.5 3.5 23.5C4.07 23.5 4.58 23.69 5 24V8.5H27Z",
    fill: "#8E8E98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 21.16L17 24.82V17.83L22.32 14.17V21.16Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26V6C1 4.62 2.12 3.5 3.5 3.5C4.07 3.5 4.58 3.69 5 4V24C4.58 23.69 4.07 23.5 3.5 23.5C2.12 23.5 1 24.62 1 26Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26C31 24.62 29.88 23.5 28.5 23.5C27.93 23.5 27.42 23.69 27 24V4C27.42 3.69 27.93 3.5 28.5 3.5C29.88 3.5 31 4.62 31 6V26Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 6H30.5V26H31.5V6Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29H3.5C1.85 29 0.5 27.65 0.5 26V6C0.5 4.35 1.85 3 3.5 3C4.16 3 4.78 3.21 5.3 3.6L5.5 3.75V25.01L4.7 24.4C4.36 24.14 3.94 24 3.5 24C2.4 24 1.5 24.9 1.5 26C1.5 27.1 2.4 28 3.5 28H28.5C29.6 28 30.5 27.1 30.5 26C30.5 24.9 29.6 24 28.5 24C28.06 24 27.65 24.14 27.3 24.4L26.5 25.01V3.75L26.7 3.6C27.22 3.21 27.84 3 28.5 3C30.15 3 31.5 4.35 31.5 6H30.5C30.5 4.9 29.6 4 28.5 4C28.14 4 27.8 4.09 27.5 4.27V23.17C27.82 23.06 28.15 23 28.5 23C30.15 23 31.5 24.35 31.5 26C31.5 27.65 30.15 29 28.5 29ZM3.5 4C2.4 4 1.5 4.9 1.5 6V23.77C2.27 23.08 3.48 22.81 4.5 23.17V4.27C4.2 4.1 3.86 4 3.5 4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8H7V9H25V8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 14.17L17 17.83L9.67999 15.84L15 12.18L22.32 14.17Z",
    fill: "#F36F4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 18.38L9.54999 16.32L9.80999 15.36L16.91 17.29L22.04 13.76L22.61 14.59L17.09 18.38Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 25.37L9.17999 23.21V15.58L14.91 11.64L22.82 13.8V21.43L17.09 25.37ZM10.18 22.45L16.91 24.29L21.83 20.91V14.57L15.1 12.73L10.18 16.11V22.45Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.83H16.5V24.82H17.5V17.83Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveModelOnMap);
export default __webpack_public_path__ + "static/media/ActiveModelOnMap.71c88bbacacb89e004fe60f7b30d4127.svg";
export { ForwardRef as ReactComponent };